import * as React from "react";

function SvgPlay(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      width="1em"
      viewBox="0 0 16 16"
      className="play_svg__Svg-ulyrgf-0 play_svg__hJgLcF"
      {...props}
    >
      <path d="M4.018 14L14.41 8 4.018 2z" />
    </svg>
  );
}

export default SvgPlay;
